import { MobiDocument } from './MobiDocument';

export class AnneeScolaireDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private datedebut: string;
    private datefin: string;
    private nom: string;
    private obsolete: boolean;

    constructor(annee: any) {
        super();
        this._id = annee._id;
        this._rev = annee._rev;
        this.id = annee.id;
        this.datedebut = annee.datedebut;
        this.datefin = annee.datefin;
        this.nom = annee.nom;
        this.obsolete = annee.obsolete
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }


    public getDatedebut(): string {
        return this.datedebut;
    }

    public setDatedebut(datedebut: string): void {
        this.datedebut = datedebut;
    }

    public getDatefin(): string {
        return this.datefin;
    }

    public setDatefin(datefin: string): void {
        this.datefin = datefin;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }

    public isObsolete(): boolean {
        return this.obsolete;
    }

    public setObsolete(obsolete: boolean): void {
        this.obsolete = obsolete;
    }

}